import { inject, injectable } from "inversify";

import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";

import {
  IGetClientInfoService,
  IAvailableDatesRequest,
  IAvailableDatesResponse,
} from "../models/IGetClientInfoService";

import { IGetClientInfoDTO } from "../dtos/IGetClientInfoDTO";

@injectable()
export class GetClientInfoService implements IGetClientInfoService {
  // @ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  public async execute(
    CNPJ: string,
    price?: boolean
  ): Promise<IGetClientInfoDTO> {
    let customer;
    if (price) {
      customer = await this.httpInstance.get<IGetClientInfoDTO>(
        `/customer/${CNPJ}?priceRequest=true`
      );
    } else {
      customer = await this.httpInstance.get<IGetClientInfoDTO>(
        `/customer/${CNPJ}`
      );
    }

    return customer;
  }

  public async availableDates(
    query: IAvailableDatesRequest
  ): Promise<IAvailableDatesResponse> {
    return await this.httpInstance.post<IAvailableDatesResponse>(
      `/orders/query-available-dates`,
      query
    );
  }
}
